import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Item, ItemContent, ItemDescription, ItemTitle } from "@/components/ui/item";
import { informationQuery } from "@/features/reseller/queries";
import { ResellerProfileView } from "@/features/reseller/reseller-profile";
import { m } from "@/lib/paraglide/messages.js";

// /settings/profile: the company and what it sent staff when it applied. Any standing reads it
// (a pending reseller is read-only, and this only reads); the account menu at the foot of the
// sidebar is the way in.
export const Route = createFileRoute("/_authenticated/settings/profile")({
  loader: ({ context }) => context.queryClient.ensureQueryData(informationQuery()),
  staticData: { crumb: m.profile_nav },
  component: ProfilePage,
});

function ProfilePage() {
  const { reseller } = Route.useRouteContext();
  const { data: information } = useSuspenseQuery(informationQuery());
  return (
    <>
      <Item>
        <ItemContent>
          <ItemTitle>{m.profile_nav()}</ItemTitle>
          <ItemDescription>{m.profile_page_description()}</ItemDescription>
        </ItemContent>
      </Item>
      <ResellerProfileView reseller={reseller} information={information} />
    </>
  );
}
